import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Delta } from 'jsondiffpatch/lib/types';
import { POLICY_TYPES_LOOKUP } from '@ag-common-lib/lib/models/utils/policy.model';
import { PolicySignersKeys } from '@ag-common-lib/lib/models/utils/policy-signers.model';
import { BaseModelKeys } from '@ag-common-lib/lib/models/base.model';
import { hasLog } from 'ag-common-svc/lib/components/changes-history-grid/utils/normalize-log';

@Component({
  selector: 'ag-shr-change-log-signed-policy',
  templateUrl: './change-log-signed-policy.component.html',
  styleUrls: ['./change-log-signed-policy.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChangeLogSignedPolicyComponent {
  @Input() log: Delta;

  protected readonly policySignersKeys = [
    PolicySignersKeys.policyVersion,
    PolicySignersKeys.policyType,
    PolicySignersKeys.lastSignedVersion,
  ];
  protected readonly policyTypesLookup = POLICY_TYPES_LOOKUP;
  protected readonly PolicySignersKeys = PolicySignersKeys;
  protected readonly BaseModelKeys = BaseModelKeys;
  protected readonly hasLog = hasLog;
}
